import { render } from "./NavigateIcon.vue?vue&type=template&id=f3932912"
import script from "./NavigateIcon.vue?vue&type=script&lang=js"
export * from "./NavigateIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/enwan/enwan-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__